import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../../ModelTraits";
import primitiveTrait from "../../Decorators/primitiveTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import anyTrait from "../../Decorators/anyTrait";
import TableColumnType from "../../../Table/TableColumnType";
import objectTrait from "../../Decorators/objectTrait";
export const THIS_COLUMN_EXPRESSION_TOKEN = "x";
export let ColumnTransformationTraits = (_dec = primitiveTrait({
  name: "Expression",
  description: "Transformation expression used to change column values (row-by-row). This uses http://bugwheels94.github.io/math-expression-evaluator . For example  `".concat(THIS_COLUMN_EXPRESSION_TOKEN, "*3` will multiply all column values by 3, `").concat(THIS_COLUMN_EXPRESSION_TOKEN, "*columnA` will multiple this column with `columnA` (note - `columnA` must be in `dependencies` array)."),
  type: "string"
}), _dec2 = primitiveArrayTrait({
  name: "Dependencies",
  description: "Array of column names which are 'injected' in to the expression. For example, to use the expression `".concat(THIS_COLUMN_EXPRESSION_TOKEN, "*columnA` (where `columnA` is the name of another column), `dependencies` must include `'columnA'`"),
  type: "string"
}), _class = class ColumnTransformationTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "expression", _descriptor, this);
    _initializerDefineProperty(this, "dependencies", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "expression", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dependencies", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let TableColumnTraits = (_dec3 = primitiveTrait({
  name: "Name",
  description: "The name of the column.",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Title",
  description: "The displayed title of the column.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Units",
  description: "The units for the column values.",
  type: "string"
}), _dec6 = objectTrait({
  name: "Transformation",
  type: ColumnTransformationTraits,
  description: "Transformation to apply to this column"
}), _dec7 = primitiveTrait({
  name: "Type",
  description: "The type of the column. If not specified, the type is guessed from " + "the column's name and values. Valid types are:\n\n" + Object.keys(TableColumnType).filter(type => isNaN(Number(type))).map(type => "  * `".concat(type, "`")).join("\n"),
  type: "string"
}), _dec8 = primitiveTrait({
  name: "Region Type",
  description: "The type of region referenced by the values in this column. If " + "`Type` is not defined and this value can be resolved, the column " + "`Type` will be `region`.",
  type: "string"
}), _dec9 = primitiveTrait({
  name: "Region Type Disambiguation Column",
  description: "The name of the column to use to disambiguate region matches in " + "this column.",
  type: "string"
}), _dec0 = primitiveArrayTrait({
  name: "Values to Replace with Zero",
  description: "Values of the column to replace with 0.0, such as `-`.",
  type: "string"
}), _dec1 = primitiveArrayTrait({
  name: "Values to Replace with Null",
  description: "Values of the column to replace with null, such as `NA`.",
  type: "string"
}), _dec10 = anyTrait({
  name: "Format",
  description: "The formatting options to pass to `toLocaleString` when formatting the values " + "of this column for the legend and feature information panels. See:\n" + "https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString\n" + "and https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat"
}), _class2 = class TableColumnTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "title", _descriptor4, this);
    _initializerDefineProperty(this, "units", _descriptor5, this);
    _initializerDefineProperty(this, "transformation", _descriptor6, this);
    _initializerDefineProperty(this, "type", _descriptor7, this);
    _initializerDefineProperty(this, "regionType", _descriptor8, this);
    _initializerDefineProperty(this, "regionDisambiguationColumn", _descriptor9, this);
    _initializerDefineProperty(this, "replaceWithZeroValues", _descriptor0, this);
    _initializerDefineProperty(this, "replaceWithNullValues", _descriptor1, this);
    _initializerDefineProperty(this, "format", _descriptor10, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "units", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "transformation", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "regionType", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "regionDisambiguationColumn", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "replaceWithZeroValues", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "replaceWithNullValues", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "format", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { TableColumnTraits as default };